import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Segment, Statistic } from 'semantic-ui-react'

export default class OrderStatistic extends React.PureComponent {
  filterOrder = (conditions, field) => {
    let { orders } = this.props

    orders = _.filter(orders, order => conditions.includes(order[field]))

    return orders.length.toLocaleString()
  }

  filterOrderAVGDuration() {
    const { orders } = this.props

    const etaArr = _.map(orders, ({ eta }) => {
      if (eta) {
        return Number(eta)
      }

      return 0
    })
    return moment.duration(_.mean(etaArr), 'minutes').format('h [hrs] m [min]')
  }

  render() {
    const items = [
      {
        key: 'all',
        label: 'All Orders',
        value: this.filterOrder(['rejected', 'delivered'], 'status'),
      },
      // {
      //   key: 'progress',
      //   label: 'In Progress Orders',
      //   value: this.filterOrder(
      //     ['pending', 'drivers_not_available', 'confirmed', 'outForDelivery'],
      //     'status'
      //   ),
      //   color: 'orange',
      // },
      {
        key: 'completedd',
        label: 'Completed Orders',
        value: this.filterOrder(['delivered'], 'status'),
        color: 'green',
      },
      {
        key: 'rejected',
        label: 'Rejected Orders',
        value: this.filterOrder(['rejected'], 'status'),
        color: 'red',
      },
      {
        key: 'eta',
        label: 'AVG Delivery ETA',
        value: this.filterOrderAVGDuration(),
      },
    ]

    return (
      <Segment>
        <Statistic.Group items={items} widths="four" />
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/orderStatistic.js